<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{row}">
        <el-tag
          size="mini"
          :type="
            row.amzFbaShipmentStatus === 'N' || row.amzFbaShipmentStatus === 'Y'
              ? 'primary'
              : row.amzFbaShipmentStatus === 'C'
              ? 'success'
              : row.amzFbaShipmentStatus === 'D'
              ? 'danger'
              : 'warning'
          "
        >
          {{ row.v_amzFbaShipmentStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{row}">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: {code: row.amzFbaShipmentCode},
                  query: {amzFbaShipmentNo: row.amzFbaShipmentNo},
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
            v-show="row.amzFbaShipmentStatus === 'N'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: {code: row.amzFbaShipmentCode},
                  query: {amzFbaShipmentNo: row.amzFbaShipmentNo},
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_export') || '导出'"
            placement="top"
          >
            <i class="el-icon-download tool-btn" @click="exportData(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    openEditPage({pageType, params = {}, query = {}}) {
      this.$router.push({
        name: 'ecom-awsBiz-fbaShipment-detail',
        params: {...params, pageType},
        query,
      })
    },
    exportData(row) {
      const url = '/ecom/amz/fba/shipment/export'
      const fileName = `${row.amzFbaShipmentNo}_${new Date().getTime()}`
      this.$api.globalExportData(url, {...row}, fileName)
    },
  },
}
</script>
